import { useContext } from 'react';
import { StoreContext } from '../StoreProvider';

const useCssUrl = () => {
    const { settings, customerData } = useContext(StoreContext);

    if (!settings || !customerData) {
        return;
    }

    return customerData.theVideoGramStore.css_uri;
}

export default useCssUrl;
